import * as React from 'react';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {Illustration} from 'shells/illustrations/illustration';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {useGetEditionsDashboard} from '../graphql/hooks';

import {EditionsList} from './editions-list';
import {EditionsTable} from './editions-table';

type Props = {
    timespan: string;
};

export function EditionsCard(props: Props) {
    const {editionsDashboard, isLoading} = useGetEditionsDashboard({timespan: props.timespan});

    const stats = editionsDashboard ? editionsDashboard.stats : [];
    const recentEditions = editionsDashboard ? editionsDashboard.recentEditions : [];
    const scheduledEditions = editionsDashboard ? editionsDashboard.scheduledEditions : [];
    const draftEditions = editionsDashboard ? editionsDashboard.draftEditions : [];
    const {onOpen: onOpenBroadcastsModal} = useOpenableModal(OpenableModals.BROADCAST_INFO_MODAL);

    return (
        <DashboardCard
            title='Broadcasts & newsletters'
            subtitle='Reach out to thousands at a time with one well-designed message'
            isLoading={isLoading}
            mainContent={{
                statsProps: {
                    stats,
                    isHorizontal: true,
                },
                content: <EditionsTable editions={recentEditions} timespan={props.timespan} />,
            }}
            sideContentProps={{
                content: (
                    <EditionsList
                        scheduledEditions={scheduledEditions}
                        draftEditions={draftEditions}
                    />
                ),
                isFullHeight: true,
            }}
            promoStateOverlay={
                editionsDashboard && editionsDashboard.totalCount === 0 ? (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: false,
                            imageComponent: (
                                <Illustration src='trial-onboarding/marketing-broadcasts-newsletters' />
                            ),
                            title: 'Email marketing powered by CRM',
                            subtitle:
                                'Send your audience beautiful emails that you can write, design, send and report on - right from Nutshell.',
                            primaryCta: {
                                text: 'Learn more',
                                onClick: onOpenBroadcastsModal,
                            },
                            secondaryCta: {
                                text: 'Create new broadcast',
                                url: '/email-marketing/broadcasts?view=board&sort=-modifiedTime',
                            },
                            blueImageBackground: true,
                        }}
                        align='right'
                    />
                ) : null
            }
        />
    );
}
